export const MODULE_ICON_MAX_SIZE = 20;
export const SECTION_ICON_MAX_SIZE = '900';

// panels
export const TAB_CONTENT = 'content';
export const TAB_DESIGN = 'design';
export const TAB_ADD = 'add';
export const TAB_EDIT = 'edit';
export const TAB_SEND_OPTIONS = 'send-options';
export const TAB_SCHEDULE = 'schedule';
export const TAB_SETUP = 'setup';
export const TAB_AUTOMATE = 'automate';
export const TEMPLATE_SUB_TAB = 'template';
export const BODY_PATTERN = 'BODY_PATTERN';
export const HUBSPOT_BRANDING_SECTION = 'HUBSPOT_BRANDING_SECTION';
export const SECTION = 'SECTION';
export const ELEMENT = 'ELEMENT';
export const INBOX = 'INBOX';
export const BUILTIN_FOOTER = 'email_can_spam';
export const BUILTIN_WEBVERSION = 'email_view_as_web_page';
export const SECTION_LIMIT = 8;
export const SIDEBAR_WIDTH = 435;
export const SIDEBAR_INLINE_PADDING = '500';
export const SIDEBAR_INDENTATION = 20;